import { forwardRef } from 'react'

import { useStyles } from './styles'

interface TextareaInnerProps
  extends Omit<React.ComponentProps<'textarea'>, 'onChange'> {
  value?: string
  error?: string
  onChange?: (
    value: string,
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => void
}

export type TextareaProps = React.ComponentProps<typeof Textarea>

const LIMIT = 600
const LIMIT_TO_START_SHOWING = 150
const LIMIT_TO_WARNING_SHOWING = 50

export const Textarea = forwardRef(
  (
    { value, error, onChange, ...props }: TextareaInnerProps,
    ref: React.LegacyRef<HTMLTextAreaElement>,
  ) => {
    const classes = useStyles()

    const counter = LIMIT - Number(value?.length)
    const isOverFirstLimit = counter <= LIMIT_TO_START_SHOWING
    const isOverSecondLimit = counter <= LIMIT_TO_WARNING_SHOWING

    return (
      <div className={classes.container}>
        <div>
          <textarea
            data-error={!!error}
            ref={ref}
            value={value}
            onChange={(e) => onChange?.(e.target.value.slice(0, LIMIT), e)}
            {...props}
          />
          {isOverFirstLimit && (
            <span title='Contador' data-limit={isOverSecondLimit}>
              {counter}
            </span>
          )}
        </div>
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'
